export const roundTwoDecimals = (value) => {
  if (value === undefined || value === null || Number.isNaN(value)) return 0;
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
};

export const getBchFromRecord = (record) => {
  if (record?.balance_change !== undefined && record.balance_change !== null) {
    return record.balance_change * 1e-8;
  }

  if (record?.bch !== undefined && record.bch !== null) {
    return record.bch;
  }

  return null;
};

// Amounts provided by the backend (tx.ars / tx.usd) are the source of truth.
// Only fall back to historical rates when those values are missing.
export const calculateArsAmount = (record) => {
  if (!record) return 0;

  if (record.ars !== undefined && record.ars !== null) {
    return record.ars;
  }

  const { historical_ars_rate, historical_bch_rate, usd } = record;

  if (usd !== undefined && usd !== null && historical_ars_rate !== undefined && historical_ars_rate !== null) {
    return usd * historical_ars_rate;
  }

  const bch = getBchFromRecord(record);

  if (bch !== null && historical_bch_rate !== undefined && historical_bch_rate !== null && historical_ars_rate !== undefined && historical_ars_rate !== null) {
    return bch * historical_bch_rate * historical_ars_rate;
  }

  return 0;
};

export const calculateUsdAmount = (record) => {
  if (!record) return 0;

  if (record.usd !== undefined && record.usd !== null) {
    return record.usd;
  }

  const { historical_bch_rate } = record;

  const bch = getBchFromRecord(record);

  if (bch !== null && historical_bch_rate !== undefined && historical_bch_rate !== null) {
    return bch * historical_bch_rate;
  }

  return 0;
};

export const formatTransactionMount = (record, _currency, formatter) => {
  const currency = _currency?.toLowerCase();
  const format = formatter ?? ((value, currencyCode) => value); // Fallback formatting only for testing

  if (currency === 'usd') {
    return format(roundTwoDecimals(calculateUsdAmount(record)), currency);
  }

  return format(roundTwoDecimals(calculateArsAmount(record)), currency ?? _currency);
};

export const refundedFormatMount = (record, _currency, formatter) => {
  const currency = _currency.toLowerCase();
  const format = formatter ?? ((value, currencyCode) => value); // Fallback formatting only for testing

  if (currency === 'ars') {
    const mountARS = roundTwoDecimals(calculateArsAmount(record));

    if (record.refunded_amount) {
      const adjusted = Math.max(0, roundTwoDecimals(mountARS - record.refunded_amount));
      return format(adjusted, currency);
    }

    return format(mountARS, currency);
  }

  const mountUSD = roundTwoDecimals(calculateUsdAmount(record));

  if (record.refunded_amount) {
    const rate = record.historical_ars_rate ?? record.usd_ars;
    const refundedUSD = rate ? roundTwoDecimals(record.refunded_amount / rate) : 0;
    const adjusted = Math.max(0, roundTwoDecimals(mountUSD - refundedUSD));
    return format(adjusted, currency);
  }

  return format(mountUSD, currency);
};
